<template>
  <div class="ui-date-field">
    <VueCtkDateTimePicker
      v-bind="$attrs"
      :value="value"
      :color="$style.accent"
      :button-color="$style.accent"
      class="custom-date-time-picker custom-date-time-picker--range"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'AppDateRangePicker',
  components: { VueCtkDateTimePicker },
  inheritAttrs: false,
  props: {
    value: { type: [Object, String], default: null },
    ariaLabel: { type: String, default: '' }
  },
  mounted() {
    this.syncAriaLabel()
  },
  updated() {
    this.syncAriaLabel()
  },
  methods: {
    syncAriaLabel() {
      if (!this.ariaLabel) return
      const input = this.$el.querySelector('input')
      if (input) input.setAttribute('aria-label', this.ariaLabel)
    }
  }
}
</script>

<style lang="scss" module>
:export { accent: $ui-blue; }
</style>
